import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadingAction } from 'store/globalState/global';
import { setSplashScreen } from 'modules/app';
import SignupComponents from '../components';
import { setAutoNavigation } from '../../MainPage/modules/mainPage';
import { doSignup, uploadImage, doSignupSocial } from '../modules/signup';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.signup,
    signupData: state.signup,
    userLang: state.i18n.language,
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showLoading: bindActionCreators(loadingAction, dispatch),
    doSignup: bindActionCreators(doSignup, dispatch),
    uploadImage: bindActionCreators(uploadImage, dispatch),
    doSignupSocial: bindActionCreators(doSignupSocial, dispatch),
    setAutoNavigation: bindActionCreators(setAutoNavigation, dispatch),
    setSplashScreen: bindActionCreators(setSplashScreen, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignupComponents));



// WEBPACK FOOTER //
// ./src/routes/SignupTemp/container/index.js